import { isNil } from 'lodash';

/*
 * Helper to consolidate the logic needed
 * for the kpi panels in the entity overview
 * pages.
 * 
 */

const createLabel = (entity, dashboardIsCurrentTimeStamp) => {
    if (entity === 'SiteEquipment') {
        return 'Average Equipment Score';
    } else if (entity === 'SiteSystem') {
        return 'Average System Score';
    } else if (entity === 'Equipment' || entity === 'System') {
        if (dashboardIsCurrentTimeStamp) {
            return 'Overall Score';
        } else {
            return `Average ${entity} Score`;
        }
    } else {
        return `Average ${entity} Score`;
    }
};

export const renderScoreData = (kpis, entity, dashboardIsCurrentTimeStamp) => {
    const data = [
        {
            value: isNil(kpis.averageScore) ? '-' : renderValue(kpis.averageScore),
            label: createLabel(entity, dashboardIsCurrentTimeStamp)
        },
        {
            value: isNil(kpis.percentChange) ? '-' : renderValue(kpis.percentChange),
            label: isNil(kpis.percentChange) ? '' : '%Change from Previous Period',
            icon:  renderIcon(kpis.percentChange)
        }
    ];

    return data;
};

export const renderFaultData = kpis => {
    const data = [
        {
            value: kpis.totalFaults,
            label: 'Current Period Faults'
        },
        {
            value: kpis.previousTotalFaults,
            label: 'Previous Period Faults'
        }
    ];

    return data;
};

export const renderIcon = value => {
    if (value) {
        if ((value * 100) > 0) {
            return '/assets/images/green_arrow_up.svg';
        } else {
            return '/assets/images/red_arrow_down.svg';
        }
    } else {
        return '';
    }
};

const renderValue = value => {
    if ((value * 100) % 1 !== 0) {
        return (value * 100).toFixed(2) + '%';
    }

    return value * 100 + '%';
};
